import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Icon } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import styles from './styles.module.scss';
/** Renders a single button in the bulleten editor toolbar */
export function ToolbarButton({ icon, disabled, active, onClick, children, }) {
    return (_jsxs(Button, Object.assign({ className: styles.toolbarButton, disabled: disabled, variant: active ? 'primary' : 'secondary', onMouseDown: (e) => {
            // So the editor doesn't loose focus
            e.preventDefault();
            onClick && onClick();
        } }, { children: [_jsx(Icon, { className: classnames({
                    [styles.toolbarIconMargin]: !!children,
                }), name: icon }), children] })));
}
